import {
  isStrongNotification,
  isWeakNotification,
} from "~/config/user/user-notifications/utils/filters";
import type { UserBadgeNotifications } from "~/config/user/user-notifications/utils/types";

function getDisplayNotificationCount(notifications: UserBadgeNotifications) {
  const strongNotificationsCount =
    notifications.filter(isStrongNotification).length;

  const weakNotificationsCount =
    notifications.filter(isWeakNotification).length;

  return {
    strongNotificationsCount,
    weakNotificationsCount,
  };
}

export { getDisplayNotificationCount };
